import { render, staticRenderFns } from "./BattlePage.vue?vue&type=template&id=224b12f0"
import script from "./BattlePage.vue?vue&type=script&lang=js"
export * from "./BattlePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports